import { useSyncExternalStore } from 'react';
import dictateModeService, { DICTATE_STATES } from '@/lib/dictateMode';

const subscribe = listener => dictateModeService.subscribeState(listener);
const getSnapshot = () => dictateModeService.getState();
const getServerSnapshot = () => DICTATE_STATES.IDLE;

// The composer owns its overlay subscription. The mic button unmounts as
// soon as a transcript gives the input text, before the final idle event.
export default function useDictateState() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
